import React, { Component } from 'react';
import TransportsWRTTable from './TransportsWRTTable';


export class TransportsWRTContent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      content: this.props.showContent
    };
  }

  render() {

    return (
      <div>
        {this.state.content === 'transportsWaitingRequest' ?
          <TransportsWRTTable handleChangeContent={this.props.handleChangeContent.bind(this)} />
          : null
        }
      </div>
    )

  }
}

export default TransportsWRTContent;


// WEBPACK FOOTER //
// ./src/components/Transports/WaitingRequest/TransportsWRTContent.js